import { useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import { liveSessions } from "../../data/liveSessions";
import { Comments } from "../../Components/common/Comments/Comments";
import { VideoCard } from "../../Components/ui/VideoCard/VideoCard";
import { Livesessions } from "../home/livesessions/livesessions";
import youtubeIcon from "../../assets/icons/youtube-icon.svg";
import "./LiveSessionDetails.css";

export const LiveSessionDetails = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [expanded, setExpanded] = useState(false);

  const session = liveSessions.find((s) => s.slug === slug);
  const previous = liveSessions.filter((s) => s.slug !== slug);

  if (!session) {
    return (
      <div className="lsd-not-found">
        <p>Session not found.</p>
        <button onClick={() => navigate("/live-sessions")}>
          Back to Live Sessions
        </button>
      </div>
    );
  }

  return (
    <div className="lsd-page">
      {/* ── Featured Video Player ── */}
      <section className="lsd-featured">
        <Container>
          <h2 className="lsd-featured__page-title">Live Sessions</h2>
          <p className="lsd-featured__page-subtitle">
            Learn from leading doctors and specialists through focused,
            digestible video content.
          </p>

          <section className="live-section">
            <div className="lsd-featured__player-wrap">
              <img
                src={session.thumbnail}
                alt={session.title}
                className="lsd-featured__thumb"
              />
              <button
                className="lsd-featured__play-btn"
                aria-label="Play video"
              >
                <img
                  src={youtubeIcon}
                  alt="play"
                  className="lsd-featured__play-icon"
                />
              </button>
              {/* {session.isLive && (
                <span className="lsd-featured__live-badge">Live</span>
              )} */}
              <span className="lsd-featured__viewers">
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                  <circle cx="9" cy="7" r="4" />
                  <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                  <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                </svg>
                Joined {session.viewers}
              </span>
              <div className="lsd-featured__controls">
                <button className="lsd-featured__ctrl-btn" aria-label="Rewind">
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <polyline points="1 4 1 10 7 10" />
                    <path d="M3.51 15a9 9 0 1 0 .49-4.95" />
                  </svg>
                </button>
                <button
                  className="lsd-featured__ctrl-btn"
                  aria-label="Play/Pause"
                >
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="white"
                    stroke="none"
                  >
                    <rect x="6" y="4" width="4" height="16" />
                    <rect x="14" y="4" width="4" height="16" />
                  </svg>
                </button>
                <button className="lsd-featured__ctrl-btn" aria-label="Forward">
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <polyline points="23 4 23 10 17 10" />
                    <path d="M20.49 15a9 9 0 1 1-.49-4.95" />
                  </svg>
                </button>
              </div>
            </div>

            {/* Video info row */}
            <div className="lsd-featured__info-row">
              <div className="lsd-featured__info-left">
                <h3 className="lsd-featured__title">{session.title}</h3>
                <div className="lsd-featured__author-row">
                  <img
                    src={session.authorAvatar}
                    alt={session.authorName}
                    className="lsd-featured__author-avatar"
                  />
                  <div>
                    <p className="lsd-featured__author-name">
                      {session.authorName}
                    </p>
                    <p className="lsd-featured__author-role">
                      {session.authorRole}
                    </p>
                  </div>
                </div>
              </div>
              <div className="lsd-featured__actions">
                <button className="lsd-featured__action-btn">
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                    <polyline points="7 10 12 15 17 10" />
                    <line x1="12" y1="15" x2="12" y2="3" />
                  </svg>
                  Download
                </button>
                <button className="lsd-featured__action-btn">
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <circle cx="18" cy="5" r="3" />
                    <circle cx="6" cy="12" r="3" />
                    <circle cx="18" cy="19" r="3" />
                    <line x1="8.59" y1="13.51" x2="15.42" y2="17.49" />
                    <line x1="15.41" y1="6.51" x2="8.59" y2="10.49" />
                  </svg>
                  Share
                </button>
              </div>
            </div>
          </section>
        </Container>
      </section>

      {/* ── Comments + Previous Sessions ── */}
      <section className="lsd-bottom">
        <Container>
          <Row className="g-5">
            {/* Left — Comments */}
            <Col xs={12} lg={7}>
              <Comments
                comments={session.comments}
                authorAvatar={session.authorAvatar}
              />
            </Col>

            {/* Right — Previous Live Sessions */}
            <Col xs={12} lg={5}>
              <h3 className="lsd-previous__heading">Previous Live Sessions</h3>
              <div className="lsd-previous__list">
                {previous.map((s) => (
                  <Link
                    key={s.id}
                    to={`/live-sessions/${s.slug}`}
                    className="lsd-previous__link"
                  >
                    <VideoCard
                      thumbnail={s.thumbnail}
                      duration={s.duration}
                      date={s.date}
                      title={s.title}
                      description={s.description}
                      authorAvatar={s.authorAvatar}
                      authorName={s.authorName}
                      authorRole={s.authorRole}
                      hasPlay={s.hasPlay}
                    />
                  </Link>
                ))}
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* ── Coming Soon Banner ── */}
      <Livesessions />
    </div>
  );
};
